export const READY_TO_SEND_EXPERIMENT_PROPERTY = "ready_to_send_experiment_aug2026";
export const PENDING_READY_TO_SEND_ASSIGNMENT_STORAGE_KEY = "bx_pending_ready_to_send_assignment";
export const READY_TO_SEND_VARIANT_PROPERTY = "variant";

const READY_TO_SEND_EXPERIMENT_EVENT_PREFIX = "ready_to_send_modal_experiment_aug2026";
export const READY_TO_SEND_TRIGGERED_EVENT_NAME = `${READY_TO_SEND_EXPERIMENT_EVENT_PREFIX}_triggered`;
export const READY_TO_SEND_MODAL_VIEWED_EVENT_NAME = `${READY_TO_SEND_EXPERIMENT_EVENT_PREFIX}_modal_viewed`;
export const READY_TO_SEND_MODAL_DISMISSED_EVENT_NAME = `${READY_TO_SEND_EXPERIMENT_EVENT_PREFIX}_modal_dismissed`;
export const READY_TO_SEND_MODAL_SEND_CLICKED_EVENT_NAME = `${READY_TO_SEND_EXPERIMENT_EVENT_PREFIX}_modal_send_clicked`;
